import React from 'react';
import { MinusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import PropTypes from 'prop-types';

const RemoveButton = ({ removeFunction }) => {
	return <Button shape="circle" icon={<MinusOutlined />} size="small" onClick={removeFunction} />;
};

RemoveButton.propTypes = {
	removeFunction: PropTypes.func.isRequired,
};
export default RemoveButton;
